<template>
  <el-dialog v-loading="isLoading" :center="center" :close-on-click-modal="closeOnClickModal" :width="dialogWidth" :visible="dialogVisible" top="8vh"
    :before-close="handleClose" @open="onDialogOpen">
    <template #title>
      <span class="el-dialog__title">全局设置</span>
    </template>
    <div class="backgroud-white cs-editor-content">
      <el-form label-width="40%">
        <el-form-item label="自主报课">
          <el-switch :disabled="readonly" v-model="gsValues.EnableAutonomousEnrolment" />
        </el-form-item>
        <el-form-item label="是否含税">
          <el-switch :disabled="readonly" v-model="gsValues.IsTaxIncluded" />
        </el-form-item>
        <el-form-item label="组织结构图">
          <el-switch :disabled="readonly" v-model="gsValues.HasOrganizationChart" />
        </el-form-item>
      </el-form>
    </div>
    <template #footer>
      <div class="dialog-footer popup-footer">
        <el-row>
          <el-col>
            <el-button :disabled="readonly" type="primary" @click="saveChanges">确认</el-button>
          </el-col>
        </el-row>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { mixinDevice } from "@/core/mixin";

import {
  getGlobalSettingValuesByTypeList,
  saveGlobalSettingValuesByType,
} from "@/service/common.service";

const default_gsValues = {
  EnableAutonomousEnrolment: false,
  IsTaxIncluded: false,
  HasOrganizationChart: false
};

export default {
  name: "globalSettingsEditor",
  mixins: [mixinDevice],
  props: {
    center: {
      type: Boolean,
      default: true,
    },
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "400px",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: "visible",
    event: "visibleChange",
  },
  data() {
    return {
      isLoading: false,
      dialogVisible: false,
      gsValues: Object.clone(default_gsValues),
    };
  },
  created() {
    this.reloadVisible();
  },
  computed: {
    dialogWidth() {
      return !this.isMobile() ? this.width : "100%";
    },
  },
  methods: {
    // 与服务端交互数据的方法
    async loadGlobalSettingValuesByTypeListFromServer() {
      this.isLoading = true;
      try {
        let typeList = [
          this.GLOBAL.enumGlobalSettingType.EnableAutonomousEnrolment,
          this.GLOBAL.enumGlobalSettingType.IsTaxIncluded,
          this.GLOBAL.enumGlobalSettingType.HasOrganizationChart
        ];
        let result = await getGlobalSettingValuesByTypeList(typeList);
        let gsValues =
          !!result && result.success
            ? result.data
            : Object.clone(default_gsValues);
        gsValues._originalData = Object.clone(gsValues);
        this.gsValues = gsValues;
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async saveGlobalSettingValuesByTypeToServer() {
      this.isLoading = true;
      try {
        let data = Object.clone(this.gsValues, {
          exceptFields: ["_originalData"],
        });
        let result = await saveGlobalSettingValuesByType(data);
        if (!!result && result.success) {
          this.$message({
            type: "success",
            message: "全局设置保存成功。",
          });

          this.closeDialog();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    reloadVisible(newValue = this.visible) {
      if (this.dialogVisible !== newValue)
        this.dialogVisible = newValue;
    },
    resetData() {
      Object.copy(
        this.gsValues,
        { exceptFields: ["_originalData"] },
        this.gsValues._originalData
      );
    },
    showDialog() {
      this.dialogVisible = true;
      this.$emit("visibleChange", this.dialogVisible);
    },
    closeDialog(needReset = false) {
      if (needReset) this.resetData();

      this.dialogVisible = false;
      this.$emit("visibleChange", this.dialogVisible);
    },
    onDialogOpen() {
      this.loadGlobalSettingValuesByTypeListFromServer();
    },
    handleClose(done) {
      this.closeDialog(true);
    },
    saveChanges() {
      this.saveGlobalSettingValuesByTypeToServer();
    },
  },
  watch: {
    visible(newValue) {
      this.reloadVisible(newValue);
    }
  }
};
</script>

<style lang="scss" scoped>
.cs-editor-content {
  padding: 0 15%;
  overflow-y: auto;

  .el-form-item {
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/globalSettingsEditor.vue